/* Bien comme bébé — thème Automne */
(function () {
  'use strict';


  // Carrousel des bouteilles (accueil)
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track || !prev || !next) return;
    function step() { var it = track.querySelector('.m3-car__item, li'); return it ? it.getBoundingClientRect().width + 12 : 200; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next.click(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev.click(); }
    });
    window.addEventListener('resize', update);
    update();
  });


  // Page « Bouteilles » : filtres par sens
  document.querySelectorAll('[data-bottles]').forEach(function (root) {
    var chips = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('.cb-card');
    var note = root.querySelector('[data-note]');
    var count = root.querySelector('[data-count]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        var shown = 0;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          var ok = f === 'all' || card.getAttribute('data-kind') === f;
          card.hidden = !ok;
          if (ok && card.getAttribute('data-kind') !== 'pack' && card.getAttribute('data-kind') !== 'jeu') shown++;
        });
        if (note) note.hidden = f !== 'all';
        if (count) count.textContent = f === 'all' ? count.getAttribute('data-all') : shown + ' bouteille' + (shown > 1 ? 's' : '');
      });
    });
  });

  // Bouton « Ajouter au panier » du bas de fiche : remonte au formulaire
  document.querySelectorAll('[data-scroll-buy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.getElementById('ProductForm');
      if (f) { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); var add = f.querySelector('[data-add-button]'); if (add) setTimeout(function () { add.focus({ preventScroll: true }); }, 500); }
    });
  });

  // Tri des collections
  document.querySelectorAll('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Quantités du panier : envoi automatique
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
      var update = document.createElement('input');
      update.type = 'hidden';
      update.name = 'update';
      update.value = 'Mettre à jour';
      form.appendChild(update);
      form.submit();
    });
  });

  // Fiche produit
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-product-form]');
    var jsonEl = root.querySelector('[data-product-json]');
    if (!form || !jsonEl) return;

    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var qtyInput = form.querySelector('[data-qty]');
    var addon = form.querySelector('[data-addon]');
    var errorEl = form.querySelector('[data-form-error]');
    var availEl = root.querySelector('[data-availability]');
    var priceEl = root.querySelector('[data-price]');
    var moneyFormat = function (cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    };

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('.option'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }

    function markUnavailable() {
      var opts = selectedOptions();
      form.querySelectorAll('.option').forEach(function (fs, index) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice();
          test[index] = input.value;
          var matches = product.variants.filter(function (v) {
            return v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
          });
          var any = matches.some(function (v) { return v.available; });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !any);
        });
      });
    }

    function render(variant) {
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Indisponible';
        if (availEl) availEl.innerHTML = '<span class="dot dot--out" aria-hidden="true"></span> Indisponible';
        return;
      }
      idInput.value = variant.id;
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      if (availEl) {
        availEl.innerHTML = variant.available
          ? '<span class="dot dot--ok" aria-hidden="true"></span> Disponible'
          : '<span class="dot dot--out" aria-hidden="true"></span> Épuisé';
      }
      if (priceEl) {
        var html = '<div class="price' + (variant.compare_at_price > variant.price ? ' price--sale' : '') + '">' +
          '<span class="price__current">' + moneyFormat(variant.price) + '</span>' +
          (variant.compare_at_price > variant.price ? ' <s class="price__compare">' + moneyFormat(variant.compare_at_price) + '</s>' : '') +
          '</div>';
        priceEl.innerHTML = html;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media) showMedia(variant.featured_media.id);
    }

    form.querySelectorAll('.option input').forEach(function (input) {
      input.addEventListener('change', function () {
        markUnavailable();
        render(findVariant(selectedOptions()));
      });
    });
    markUnavailable();

    // Galerie
    function showMedia(id) {
      root.querySelectorAll('.gallery__item').forEach(function (el) {
        el.classList.toggle('is-active', String(el.getAttribute('data-media-id')) === String(id));
      });
      root.querySelectorAll('[data-thumb]').forEach(function (el) {
        el.classList.toggle('is-active', String(el.getAttribute('data-thumb')) === String(id));
      });
    }
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(btn.getAttribute('data-thumb')); });
    });

    // Ajout au panier (avec jeu additionnel si coché)
    form.addEventListener('submit', function (event) {
      if (!addon || !addon.checked) return; // envoi classique sans jeu
      event.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addButton.disabled = true;

      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var items = [
        { id: parseInt(idInput.value, 10), quantity: qty },
        { id: parseInt(addon.value, 10), quantity: qty, properties: { 'Pour la bouteille': (root.getAttribute('data-bottle-name') || product.title) } }
      ];

      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data.description || result.data.message || 'Ajout impossible.');
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          addButton.disabled = false;
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
    });
  });
})();
